module.exports = __webpack_public_path__ + "media/images/badge-digital-19f8a15482a6f3688a31c2ae29e32540.svg";